<p class="modal-title">HSAs during in-retirement years</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p>Health insurance can be expensive in retirement. Plus healthcare costs typically rise each year. And as we age, we tend to need more healthcare. These costs can add up!</p>
<br />
<p>You can use your HSA to pay for healthcare expenses tax-free in retirement, unlike when you withdraw from your 401(k) or other retirement accounts.</p>